import { StyleSheet } from 'react-native';
import { COLORS, FONTS } from '../../../../../constants';

export const styles = StyleSheet.create({
  table_text: {
    fontSize: 14,
    fontFamily: FONTS.AvenirMedium,
    color: COLORS.GREEN,
    textTransform: 'uppercase',
    fontWeight: '500',
  },
  titleText: {
    fontFamily: FONTS.AvenirLTStdBlack,
    textTransform: 'uppercase',
    color: COLORS.GREEN,
    fontWeight: '600',
    paddingHorizontal: 15,
    paddingVertical: 5,
    fontSize: 14,
  },
  tbody_content: {
    paddingHorizontal: 15,
    paddingVertical: 5,
  },
  countWrapper: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginBottom: 10,
  },
  count: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  countBtn: {
    width: 20,
    height: 20,
    borderWidth: 1,
    borderColor: COLORS.DARK_GREY,
  },
  countBtnText: {
    color: COLORS.BLACK,
    textAlign: 'center',
    fontSize: 13,
  },
  countText: {
    fontSize: 14,
    paddingHorizontal: 10,
    color: COLORS.BLACK,
  },
});
